export const UserRoleMapper = {
    STANDARD_USER: 'Standard User',
    NAR_ADMIN: 'NAR Administrator',
    BROKER_MANAGER: 'Broker Manager',
    ASSOCIATION_ADMIN: 'Association Admin'
};
